import type { ItemCollectionResponse } from '../types/api';
import type { AuditEvent } from '../types/audit';
import { fetchAndParse, fetchAndParseBlob } from '../utils/ajax';
import { getTenantId } from '../utils/tenant';

export const getAuditLogs = (parameters: string) =>
    fetchAndParse<ItemCollectionResponse<AuditEvent>>({
        url: `/api/audit/1/search?${parameters}`,
        headers: {
            ManyWhoTenant: getTenantId(),
        },
    });

export const downloadAuditLogsCsv = async (parameters: string) =>
    fetchAndParseBlob({
        url: `/api/audit/1/csv?${parameters}`,
        headers: {
            ManyWhoTenant: getTenantId(),
        },
    });

export const registerPublishDisclaimerEvent = async (flowId: string) => {
    await fetch(`/api/audit/1/publishdisclaimer/${flowId}`, {
        method: 'POST',
        headers: {
            ManyWhoTenant: getTenantId(),
        },
    });
};

export const registerSnapshotDisclaimerEvent = async (flowId: string) => {
    await fetch(`/api/audit/1/snapshotdisclaimer/${flowId}`, {
        method: 'POST',
        headers: {
            ManyWhoTenant: getTenantId(),
        },
    });
};
